export const DEVICE_MODEL = [
  {
    value: 1,
    label: 'TVI63781 (簡易大門口機（5吋）)',
    type: 'doorLock',
    brand: 'ALST'
  },
  {
    value: 2,
    label: 'KVR2804',
    type: 'NVR',
    brand: 'ALST'
  },
  {
    value: 3,
    label: 'NCB4823',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 4,
    label: 'NCD4823',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 5,
    label: 'NCX2816',
    type: 'LoudspeakerCam',
    brand: 'ALST'
  },
  {
    value: 6,
    label: 'NCB4822',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 7,
    label: 'NCD4822',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 8,
    label: 'HLC-6GMQ',
    type: 'Cam',
    brand: 'HUST'
  },
  {
    value: 9,
    label: 'HLV-1GMQ',
    type: 'Cam',
    brand: 'HUST'
  },
  {
    value: 10,
    label: 'HLC-6GMQ_2',
    type: 'Cam',
    brand: 'HUST'
  },
  {
    value: 11,
    label: 'HLV-1GMQ_2',
    type: 'Cam',
    brand: 'HUST'
  },
  {
    value: 12,
    label: 'NCX4822',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 13,
    label: 'HLC-6CKQ',
    type: 'Cam',
    brand: 'HUST'
  },
  {
    value: 14,
    label: 'HLC-6CKD_2',
    type: 'LoudspeakerCam',
    brand: 'HUST'
  },
  {
    value: 15,
    label: 'KVR2808',
    type: 'NVR',
    brand: 'ALST'
  },
  {
    value: 16,
    label: 'KVR2816',
    type: 'NVR',
    brand: 'ALST'
  },
  {
    value: 17,
    label: 'HNR-04KD',
    type: 'NVR',
    brand: 'HUST'
  },
  {
    value: 18,
    label: 'HNR-09KK or HNR-09KP',
    type: 'NVR',
    brand: 'HUST'
  },
  {
    value: 19,
    label: 'HNR-16KK',
    type: 'NVR',
    brand: 'HUST'
  },
  {
    value: 20,
    label: 'VMR-X2-04',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 21,
    label: 'VMR-X2-08',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 22,
    label: 'VMR-X2-16',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 23,
    label: 'VMR-X8-16',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 24,
    label: 'VMR-X8-36',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 25,
    label: 'RS2000SV-3608V',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 26,
    label: 'RS2000SV-6408V',
    type: 'VMS',
    brand: '詮創'
  },
  {
    value: 50,
    label: 'NCX4322',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 51,
    label: 'NCB4322',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 52,
    label: 'ProCam 3',
    type: 'Cam',
    brand: 'SkyWatch'
  },
  {
    value: 55,
    label: 'N3E5GN',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 56,
    label: 'N3E5MB',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 57,
    label: 'N3E5VG',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 58,
    label: 'N3E5VB',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 59,
    label: 'N3E5FG',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 60,
    label: 'NID4833_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 61,
    label: 'NID4832_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 62,
    label: 'NIB4822_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 63,
    label: 'NID4823_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 64,
    label: 'NIB4823_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 65,
    label: 'NIX4822_E',
    type: 'Cam',
    brand: 'ALST'
  },
  {
    value: 66,
    label: 'NID4822_E',
    type: 'Cam',
    brand: 'ALST'
  },
]

export function getNvrModelIdList() {
  let idArr = []
  DEVICE_MODEL.forEach(function(item, index){
    if (item.type === 'NVR') {
      idArr.push(item.value)
    }
  })
  return idArr
}

export function getCamModelIdList() {
  let idArr = []
  DEVICE_MODEL.forEach(function(item, index){
    if (item.type === 'Cam' || item.type === 'LoudspeakerCam') {
      idArr.push(item.value)
    }
  })
  return idArr
}